/**
 * Model for our action type
 * 
 * @package Ninja Forms builder
 * @subpackage Actions
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'models/actions/typeModel',[], function() {
	var model = Backbone.Model.extend( {

	} );
	
	return model;
} );
